import React from 'react';

export default function TabsListTitle({ children, className }) {
  return (
    <div className={`bmc-page-tabs-content-list-title ${className}`}>
      {children}
    </div>
  );
}
